import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const conversationSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getCoachingConversationView: builder.query({
            query: (arg: any) => {
                const {  employeeNumber,searchOracleId, teamType, userRole , fromDate, toDate, viewAllEmps} = arg;
                return {
                    url: constants.GET_COACHING_CONVERSION_VIEW,
                    params: {  employeeNumber,searchOracleId, teamType, userRole, fromDate, toDate, viewAllEmps},
                };
            },
            providesTags: ['Coaching','CoachingConversationModal'],
        }),
        getCoachingConversationSearch: builder.query({
            query: (arg: any) => {
                const {  coachingConversationId} = arg;
                return {
                    url: constants.GET_COACHING_CONVERSATION_SEARCH,
                    params: {  coachingConversationId},
                };
            },
            providesTags: ['Coaching','CoachingConversationModal'],
        }),
    }),
});

export const { useGetCoachingConversationViewQuery, useGetCoachingConversationSearchQuery } = conversationSlice;
